var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFortnox = function SvgFortnox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--huma-color-integration-fortnox)",
    d: "M656.46 194.732H499.714c-109.096 0-183.08 73.985-183.08 183.082v392.495c0 11.286 6.27 17.556 17.555 17.556h87.152c11.285 0 17.555-6.27 17.555-17.556V607.292h218.193c11.286 0 17.556-6.27 17.556-17.556v-83.39c0-11.285-6.27-17.555-17.556-17.555h-218.82V374.679c0-36.366 24.453-60.818 60.818-60.818h157.375c11.286 0 17.556-6.27 17.556-17.556v-84.017c0-11.286-6.27-17.556-17.556-17.556z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#067634",
    strokeLinecap: "round",
    strokeWidth: 69.633,
    d: "M624.818 948.287c-37.484 9.625-69.628 16.896-124.818 16.896A465.183 465.183 0 0 1 34.817 500c0-74.904 16.759-136.044 41.75-193.116"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fcc10d",
    strokeLinecap: "round",
    strokeWidth: 69.633,
    d: "M728.904 95.032A465.18 465.18 0 0 1 965.183 500c0 123.374-49.498 241.21-136.249 328.934-27.115 27.42-51.245 45.143-78.295 62.712"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#067634",
    strokeLinecap: "round",
    strokeWidth: 69.633,
    d: "M151.166 191.384C236.348 96.136 362.163 34.817 500 34.817c56.727 0 101.309 10.416 101.309 10.416"
  })));
};
export default SvgFortnox;